import React from 'react'
import { IoSearchSharp } from 'react-icons/io5'
import styled from 'styled-components'

const Button = styled.button`
  appearance: none;
  background: none;
  color: var(--black-100);
  padding: 0;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`

interface Props {
  onClick: () => void
  className?: string
}
export const SearchButton = ({ onClick, className }: Props) => (
  <Button onClick={onClick} aria-label="Search" className={className}>
    <IoSearchSharp size={24} />
  </Button>
)
